var promise = {}
var recaptcha = null

promise.promise = new Promise((resolve) => {
  promise.resolve = resolve
})

window.vueRecaptchaApiLoaded = function () {
  recaptcha = window.grecaptcha
  promise.resolve(recaptcha)
}

var getRecaptcha = function () {
  if (recaptcha !== null) {
    return Promise.resolve(recaptcha)
  }
  return promise.promise
}
var checkRecaptchaLoad = function () {
  if (window.hasOwnProperty('grecaptcha') && window.grecaptcha.hasOwnProperty('render')) {
    window.vueRecaptchaApiLoaded()
  }
}
var assertRecaptchaLoad = function () {
  if (recaptcha === null) {
    throw new Error('ReCAPTCHA has not been loaded')
  }
}
var render = function (ele, key, options) {
  return getRecaptcha().then((recaptcha) => {
    let opts = Object.assign({}, { sitekey: key }, options)
    return recaptcha.render(ele, opts)
  })
}
var reset = function (widgetId) {
  if (typeof widgetId === 'undefined') {
    return false
  }
  assertRecaptchaLoad()
  getRecaptcha().then((recaptcha) => {
    recaptcha.reset(widgetId)
  })
}

module.exports = {
  getRecaptcha: getRecaptcha,
  checkRecaptchaLoad: checkRecaptchaLoad,
  assertRecaptchaLoad: assertRecaptchaLoad,
  render: render,
  reset: reset
}



// WEBPACK FOOTER //
// ./src/client/components/recaptcha/recaptcha.js